import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceInfo from "@/components/admin/admin-workspace-info";

const AdminWorkspaceInfoPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceInfo workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/")({
	component: AdminWorkspaceInfoPage,
});
